import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'pps-project-invoice-action',
  template: `
    <button (click)="deleteInvoice()" type="button"
            *ngIf="this.params.data.id > 0 && canDeleteInvoice"
            pButton pRipple 
            label="Delete Invoice"
            class="p-button-danger p-button-sm p-mr-1"
            style="padding: 0.4rem;margin-bottom: 1.2rem; font-size:0.9rem;"
            pTooltip="Delete this invoice"
            tooltipPosition="bottom"></button>

    <button (click)="showInvoice()" type="button"
            *ngIf="this.params.data.invoiceImageUrl"
            pButton pRipple
            label="Download Invoice"
            class="p-button-success p-button-sm"
            style="padding: 0.4rem;margin-bottom: 1.2rem; font-size:0.9rem;"
            pTooltip="Download invoice attachment"
            tooltipPosition="bottom"></button>
  `,
  styles: [
  ],
})
export class ProjectInvoiceActionComponent implements AgRendererComponent {
  params: any;

  refresh(params: any): boolean {
    return false;
  }

  agInit(params: import("ag-grid-community").ICellRendererParams): void {
    this.params = params;
  }

  afterGuiAttached?(params?: import("ag-grid-community").IAfterGuiAttachedParams): void {
    throw new Error("Method not implemented.");
  }

  showInvoice(){
    this.params.context.componentParent.showInvoiceImage(this.params.data);
  }

  deleteInvoice(){
    this.params.context.componentParent.deleteInvoice(this.params.data);
  }

  get canDeleteInvoice(){
    return this.params.context.componentParent.parent.canDeleteInvoice();
  }
}
